import { Routes, Route } from "react-router-dom";

import Inicio from "./pages/Inicio";
import Menu from "./components/Menu";
import Animes from "./pages/Animes";
import Reproductor from "./components/Reproductor";

function Anime() {
  return (
    <div className="anime">
      <Menu></Menu>

      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/animes" element={<Animes />} />
      </Routes>
    </div>
  );
}

export default Anime;
